import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Chat from '../Chat/index'; 

function Chats() { 
  return (
    <Routes>
      <Route path="/" element={<ChatsList />} />
      <Route path="*" element={<Navigate to="/chats" replace />} />
    </Routes>
  );
}

function ChatsList() {
  console.log('ChatsList component rendering');
  return (
    <div className="h-full bg-blue-100 p-4">
      <Chat />
    </div>
  );
}

export default Chats; 